<template>
	<div>
		<!-- 活动轮播模块 -->
		<div class="swiper-people" v-if="activityList.length>0">
			<mt-swipe :auto="4000" class="swiper">
          <mt-swipe-item
          v-for="(item,index) in activityList" :key="index" @click.native='routeActivity(item)'
          >
           <div class="swiper-item uni-bg-red">
			   <img  class="swiper-item-image" :src="item.materialClusterDTO.bannerMaterialUrl" alt="">
					</div> 
          </mt-swipe-item>
        </mt-swipe>
		</div>
	</div>
</template>
<script>
	export default{
		props:{
			showSetting:{
				type:Number,
				default:1
			},
			pagetype:{
				type:String,
				default:''
			},
			bookId:{
				type:String,
				default:''
			},
			chapterId:{
				type:String,
				default:''
			}
		},
		
		data(){
			return {
				activityList:[]
			}
		},
		mounted() {
			console.log('test')
			// this.findRechargeActivity();
		},
		methods:{
			handleChange(val){
				// if(this.activityList.length-1>=val){
				// }
				// console.log(val)
			},
			findRechargeActivity(){
				    var params = {
				      showSetting: this.showSetting,
					  sourceVersion:1
				    }
				    this.$api.findRechargeActivity(params)
				      .then((res) => {
				        if (res.status === 1 ) {
				          this.activityList = res.data;
				        } else {
				          this.activityList = [];
				        }
				      }).catch(res => {
					console.log(res)
					// 失败进行的操作
				})
			},
			routeActivity(item){
				console.log(item)
				console.log(this.bookId)
				console.log(this.chapterId)
				  var pageType = 'bookCharge';
				    if (this.showSetting == 2) {
				        pageType = 'bookTask';
				    } else if (this.showSetting == 3) {
				         pageType = 'bookMine';
				    }
					this.$router.push({
						path:'/pages/bookModelActivity/index',
						query:{
							activityId:item.id,
							pageType:pageType,
							isBookRead:this.pagetype,
							bookId:this.bookId,
							chapterId:this.chapterId
						}
					})
			}
		}
	}
</script>

<style scoped>
	.swiper-people{
		margin-top: 16px;
	}
	.swiper{
	width: 328px;
	height: 90px;
	}
	.swiper-item{
		width:100%;
	height: 90px;
	}
	.swiper-item-image{
		width: 100%;
		height: 100%;
		border-radius: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/view/components/activity-swiper.vue